import type { ReportingPeriod } from '@/features/datahub/periods/types';

export interface SelectableReportingPeriod {
  id: string;
  name: string;
  label: string;
  startDate: string;
  endDate: string;
}

function comparePeriodsDesc(
  a: Pick<SelectableReportingPeriod, 'startDate'>,
  b: Pick<SelectableReportingPeriod, 'startDate'>
): number {
  return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
}

export function buildSelectableReportingPeriods(
  periods: ReportingPeriod[]
): SelectableReportingPeriod[] {
  return periods
    .map((period) => ({
      id: period.id,
      name: period.name,
      label: period.name,
      startDate: period.startDate,
      endDate: period.endDate,
    }))
    .sort(comparePeriodsDesc);
}
